// actions

import {
  // preload middleware
  LOAD_MACMILLAN_SUCCESS,
  // activity flow and control
  ACTIVITY_SUCCESS,
  ACTIVITY_FAILURE,
  LOAD_ACTIVITY_COMPLETION_TIME_SUCCESS,
  LOAD_ACTIVITY_COMPLETION_TIME_FAILURE,
  LOAD_PROGRESS_SUCCESS,
  LOAD_PROGRESS_FAILURE,
  SAVE_PROGRESS_SUCCESS,
  LOAD_STUDENT_ROSTER_SUCCESS,
  PAUSE_ACTIVITY,
  RESUME_ACTIVITY,
  NEXT_ITEM,
  SAVE_ATTEMPT,
  SHOW_ANSWER,
  SHOW_HINT,
  HIDE_HINT,
  SET_TARGET_SCORE,
  SET_ENABLED_TOPICS,
  // modal
  TIPS_FOR_SUCCESS,
  CLOSE_TIPS_FOR_SUCCESS,
  CLOSE_MID_ACTIVITY_MODAL,
  CLOSE_COMPLETED_ACTIVITY_MODAL,
  CLOSE_INCORRECT_MODAL,
  CLOSE_SLOW_DOWN_MODAL,
  CLOSE_SLOW_DEDUCT_MODAL,
  CLOSE_EBOOK_MODAL,
  CLOSE_SPLIT_SCREEN_EBOOK_MODAL,
  CHALLENGE_QUESTION_MODAL,
  CLOSE_CHALLENGE_QUESTION_MODAL,
  CLOSE_CHALLENGE_SENT_MODAL,
  SHOW_EBOOK,
  SHOW_PSP_EBOOK,
  SHOW_SPLIT_SCREEN_EBOOK,
  // challenge question
  CHALLENGE_SUCCESS,
  CHALLENGE_FAILURE,
  CHANGE_CHALLENGE_VALUE,
  CHALLENGE_INVALID,
  // sample results
  VIEW_SAMPLE_RESULTS,
  VIEW_SAMPLE_LCRP_RESULTS,
  HIDE_SAMPLE_RESULTS,
  VIEW_SAMPLE_TRENDS_DATA,
  HIDE_SAMPLE_TRENDS_DATA,
  // tool tips
  SHOW_SCORE_TOOLTIP,
  SHOW_QUESTION_TOOLTIP,
  // misc
  CONTACT_TECH_SUPPORT,
  FAQ,
  UPDATE_RADIO_BUTTONS,
  CHANGE_CHALLENGE_ISSUE_TYPE,
  CHALLENGE_INVALID_ISSUE_TYPE,
  NEXT_CHALLENGE_STEP,
  CHANGE_CHALLENGE_EMAIL_VALUE, CHALLENGE_INVALID_EMAIL,
  UPDATE_NETWORK_STATUS,
  NETWORK_STATUS_UP,
  NETWORK_STATUS_DOWN,
  SHOW_NETWORK_ISSUE_MODAL, CLOSE_NETWORK_ISSUE_MODAL
} from '../actions'

import { ACTION_CALL_TIME } from '../middleware/timing'

// imports

import _ from 'lodash'

import {
  defaultTargetScore
} from '../lib/legacy/legacyActivityBuilder'

import {
  nextTestCard,
  checkAnswer,
  checkQuestionTime,
  getEbookPageIdForCurrentQuestion
} from '../lib/legacy/legacyEngine'

import {
  simulateInstructorData,
  finishInitialization
} from '../lib/legacy/legacyArgaService'

import {
  isValidPageId
} from '../lib/launchpad'

import getConfig from '../lib/params'

import {
  constructRosterObjects,
  saveMacmillanAssignmentSettings,
  calculateCourseDashboardData
} from '../lib/macmillan'

import {
  MINIMUM_QUESTION_TIME,
  defaultState,
  didActivityJustComplete,
  didActivityJustCrossHalfway,
  shouldShowIncorrectModal,
  shouldShowSuccessModal,
  isSplitScreenEbookAvailable,
  getHint
} from './reducerHelpers'

import { buildRetake } from '../../lcrp/lib/retake.js'
import {
  simulateLCRPData,
  simulateLCRPTopicalPerformance
} from '../../lcrp/lib/fakeData'

// reducer switch

export default function core (state = defaultState, action) {
  const { type, response } = action

  // returns LaunchPad config
  const config = getConfig()

  // questionIndex is a query parameter used to 'pin' a single question for testing
  const questionIndex = config.questionIndex
    ? config.questionIndex
    : window.questionIndex

  let activity, uiState

  switch (type) {
    // preload reducers

    case LOAD_MACMILLAN_SUCCESS: {
      const thisResponse = response
      // macmillan_user_id is included in the PTP framework's response
      // it is restored from the DB after a successful association and will be present if a load is successful
      if (thisResponse.macmillan_user_id) {
        state.initialUserData = thisResponse
        state.isStandalone = true
      } else {
        state.initialUserData = null
        state.isStandalone = thisResponse.isStandalone
      }
      state.config = action.config
      uiState = _.cloneDeep(state.uiState)
      return { ...state, activity, uiState }

    // activity flow and control reducers
    }
    case ACTIVITY_FAILURE:
      return { ...state }
    case ACTIVITY_SUCCESS:
      activity = action.payload
      uiState = _.cloneDeep(state.uiState)
      uiState.isInstructorView = config.isInstructorView
      if (activity.config.skipStartPage) {
        nextTestCard(activity, questionIndex, state.config)
        uiState.questionStartTime = action[ACTION_CALL_TIME]
      }

      return { ...state, activity, uiState }
    case LOAD_ACTIVITY_COMPLETION_TIME_FAILURE:
      return { ...state }
    case LOAD_ACTIVITY_COMPLETION_TIME_SUCCESS:
      activity = _.cloneDeep(state.activity)
      activity.courseAvgTime = action.payload.avgTime
      activity.courseEstTime = action.payload.estTime
      return { ...state, activity }
    case LOAD_PROGRESS_FAILURE:
      return { ...state }
    case LOAD_PROGRESS_SUCCESS: {
      activity = _.cloneDeep(state.activity)

      if (activity.config.isInstructorView === true || activity.config.simulateData !== undefined) {
        return state
      }

      const progress = action.payload

      uiState = _.cloneDeep(state.uiState)

      if ((activity.config.demo || activity.studentData.user_id_type === 'macmillan') &&
        progress) {
        activity.completedTimestamp = progress.completedTimestamp
        activity.score.activityScore = progress.score || 0
        activity.timeOnTask = progress.timeOnTask

        if (progress.tp) {
          for (let i = 0; i < activity.allTopics.length; i++) {
            const t = activity.allTopics[i]
            t.questionsReceived = progress.tp[i].qr
            t.nextLevel = progress.tp[i].nl
            t.totalPointsAvailable = progress.tp[i].pa
            t.totalPointsEarned = progress.tp[i].pe
          }

          for (let i = 0; i < activity.topics.length; i++) {
            const t = activity.topics[i]
            const topicId = activity.topics[i].topicId;
            t.questionsReceived = progress.tp[topicId].qr
            t.nextLevel = progress.tp[topicId].nl
            t.totalPointsAvailable = progress.tp[topicId].pa
            t.totalPointsEarned = progress.tp[topicId].pe
          }
        }

        activity.studentData.activity_questions_received = progress.qr || 0

        activity.score.completedQuestionCount = progress.completedQuestionCount || 0
        activity.questions = mergeQuestionViewData(activity.questions, progress.questions)

        if (!config.simulateRetake && config.demo) {
          buildRetake(activity, progress)
        }

        if (activity.studentData.isRetake === 1) {
          uiState.isRetake = 1
        }

        return { ...state, activity, uiState }
      } else {
        return { ...state }
      }
    }
    case SAVE_PROGRESS_SUCCESS: {
      const progress = action.payload
      activity = _.cloneDeep(state.activity)
      activity.timeOnTask = progress.activity_state.timeOnTask
      return { ...state, activity }
    }
    case LOAD_STUDENT_ROSTER_SUCCESS: {
      activity = _.cloneDeep(state.activity)
      uiState = _.cloneDeep(state.uiState)

      const rosterObjects = constructRosterObjects(activity, action.payload.dashboardRoster)

      // DEV note: This is just logging the base calculations in MLLC-1089
      if (activity.config.isInstructorView) {
        const dashboardRoster = action.payload.dashboardRoster ? action.payload.dashboardRoster : []
        state.courseDashboardData = calculateCourseDashboardData(activity, dashboardRoster)
      }

      const avgTime = action.payload.avgTime
      const estTime = action.payload.estTime
      activity.courseAvgTime = avgTime
      activity.courseEstTime = estTime

      Object.assign(activity, rosterObjects)

      return { ...state, activity, uiState }
    }
    case NEXT_ITEM:
      activity = _.cloneDeep(state.activity)

      nextTestCard(activity, questionIndex, state.config)
      activity.score.hint = null
      activity.score.curCard.userAnswer = null // re-appearing questions should not have the old userAnswer

      uiState = _.cloneDeep(state.uiState)
      uiState.questionStartTime = action[ACTION_CALL_TIME]
      uiState.isIncorrectModalDisplayed = false
      uiState.isSuccessModalDisplayed = false
      uiState.showScoreValueInfo = false
      uiState.showQuestionValueInfo = false

      return { ...state, activity, uiState }

    case PAUSE_ACTIVITY:
      activity = _.cloneDeep(state.activity)
      uiState = _.cloneDeep(state.uiState)

      // resets state of ebok modal
      uiState.isSplitScreenEbookDisplayed = false
      uiState.isLegacyEbookDisplayed = false

      return { ...state, activity, uiState }

    case RESUME_ACTIVITY:
      activity = _.cloneDeep(state.activity)
      uiState = _.cloneDeep(state.uiState)
      if (!activity.score.curCard) {
        nextTestCard(activity, questionIndex, state.config)
        uiState.questionStartTime = action[ACTION_CALL_TIME]
        activity.score.hint = null
        activity.score.curCard.userAnswer = null // re-appearing questions should not have the old userAnswer
      }
      uiState.isEbookAvailable = isValidPageId(getEbookPageIdForCurrentQuestion(activity))
      if (isSplitScreenEbookAvailable(activity)) {
        uiState.isSplitScreenEbookAvailable = true
      } else {
        uiState.isSplitScreenEbookAvailable = false
      }

      uiState.isSplitScreenEbookDisplayed = false
      uiState.isLegacyEbookDisplayed = false

      // if we're starting a new quiz, increment this to 1
      if (activity.studentData.activity_questions_received === 0 && !config.isInstructorView) {
        activity.studentData.activity_questions_received++
      }

      return { ...state, activity, uiState }

    case SAVE_ATTEMPT:
      activity = _.cloneDeep(state.activity)
      uiState = _.cloneDeep(state.uiState)

      // determine answer type
      if (activity.score.curCard.questionType === 'MC') {
        activity.score.curCard.userAnswerIndex = parseInt(action.payload, 10)
      } else if (activity.score.curCard.questionType === 'FB') {
        activity.score.curCard.userAnswer = _.toString(action.payload)
      } else if (activity.score.curCard.questionType === 'SC') {
        activity.score.curCard.userAnswerIndex = parseInt(action.payload, 10)
      }
      checkAnswer(activity.score)

      // does the user need to slow down?
      if (activity.score.curCard.answeredWrong > 0 && !activity.score.curCard.completed) {
        if (action[ACTION_CALL_TIME] - uiState.questionStartTime < MINIMUM_QUESTION_TIME) {
          checkQuestionTime(activity.score, false)
          if (activity.score.reductionsSinceLastWarning === 1) {
            uiState.isSlowDownModalDisplayed = true
          } else if (activity.score.reductionsSinceLastWarning >= 3 &&
          activity.score.initialPointsReductionFactor < 0.5) {
            uiState.isSlowDeductModalDisplayed = true
          }
        }
      }
      activity.score.hint = null

      // handle modal display
      uiState.isMidActivityModalDisplayed = didActivityJustCrossHalfway(state.activity, activity)
      uiState.isCompletedActivityModalDisplayed = didActivityJustComplete(state.activity, activity)
      uiState.isIncorrectModalDisplayed = shouldShowIncorrectModal(activity)
      uiState.isSuccessModalDisplayed = shouldShowSuccessModal(activity)
      if (uiState.isSuccessModalDisplayed) {
        if (!activity.score.completedQuestionCount) {
          activity.score.completedQuestionCount = 1
        } else {
          activity.score.completedQuestionCount++
        }
      }

      return { ...state, activity, uiState }

    case SHOW_ANSWER:
      activity = _.cloneDeep(state.activity)
      activity.score.curCard.givenUp = true
      activity.score.curCard.completed = true
      activity.score.curCard.pointsAvailable = 0
      activity.score.hint = null

      uiState = _.cloneDeep(state.uiState)
      if (action[ACTION_CALL_TIME] - uiState.questionStartTime < MINIMUM_QUESTION_TIME) {
        checkQuestionTime(activity.score, false)
        if (activity.score.reductionsSinceLastWarning === 1) {
          uiState.isSlowDownModalDisplayed = true
        } else if (activity.score.reductionsSinceLastWarning === 3 && activity.score.initialPointsReductionFactor < 0.5) {
          uiState.isSlowDeductModalDisplayed = true
        }
      }
      uiState.isIncorrectModalDisplayed = false
      uiState.showScoreValueInfo = false
      uiState.showQuestionValueInfo = false

      return { ...state, activity, uiState }

    case SET_TARGET_SCORE:
      activity = _.cloneDeep(state.activity)
      // Check if we have loaded sample students
      if (activity.tmpSampleData !== undefined) {
        activity.tmpSampleData.score.scoreTarget = action.targetScore
      } else {
        activity.score.scoreTarget = action.targetScore
      }

      saveMacmillanAssignmentSettings(activity, state.initialUserData)

      return { ...state, activity }

    case SET_ENABLED_TOPICS: {
      activity = _.cloneDeep(state.activity)
      activity.topics = action.enabledTopics.sort((a, b) => a.topicId > b.topicId)
      // rebuild question to topic associations
      const topicMap = new Map()
      activity.topics.forEach(t => topicMap.set(t.topicId, t))
      activity.questions.forEach(q => {
        q.topic = topicMap.get(q.topic.topicId) || q.topic
      })
      activity.score.topicOrder = []
      const allTopicIds = activity.allTopics.map(t => t.topicId)
      const enabledTopicIds = action.enabledTopics.map(t => t.topicId)
      let excludedTopicIds = _.differenceWith(allTopicIds.sort(),
        enabledTopicIds.sort(), _.isEqual)
      // check if we have sample students loaded
      if (activity.tmpSampleData !== undefined) {
        activity.tmpSampleData.score.scoreTarget = defaultTargetScore(
          { topics: activity.topics, questions: activity.questions }
        )
      } else {
        activity.score.scoreTarget = defaultTargetScore(
          { topics: activity.topics, questions: activity.questions }
        )
      }
      // last failsafe to ensure that it is never the case that all topics are excluded
      if (excludedTopicIds.length === allTopicIds.length) {
        excludedTopicIds = []
      }

      activity.config.topicsExcluded = excludedTopicIds
      saveMacmillanAssignmentSettings(activity, state.initialUserData)

      return { ...state, activity }
      // end activity flow/control reducers

      // hint reducers
    }
    case SHOW_HINT:
      activity = _.cloneDeep(state.activity)
      activity.score.hint = getHint(activity.score)
      if (!activity.finalScore) {
        if (!activity.score.hintCount) {
          activity.score.hintCount = 1
        } else {
          activity.score.hintCount++
        }
      } else {
        if (!activity.studentData.rt) {
          activity.studentData.rt = {}
        }
        if (!activity.studentData.rt.hintCount) {
          activity.studentData.rt.hintCount = 1
        } else {
          activity.studentData.rt.hintCount++
        }
      }

      uiState = _.cloneDeep(state.uiState)
      uiState.isIncorrectModalDisplayed = false

      return { ...state, activity, uiState }

    case HIDE_HINT:
      activity = _.cloneDeep(state.activity)
      activity.score.hint = null

      uiState = _.cloneDeep(state.uiState)
      uiState.isIncorrectModalDisplayed = shouldShowIncorrectModal(activity)

      return { ...state, activity, uiState }

    // modal reducers
    case TIPS_FOR_SUCCESS:
      uiState = _.cloneDeep(state.uiState)
      uiState.isTipsForSuccessModalDisplayed = true
      return { ...state, uiState }

    case CLOSE_TIPS_FOR_SUCCESS:
      uiState = _.cloneDeep(state.uiState)
      uiState.isTipsForSuccessModalDisplayed = false
      return { ...state, uiState }

    case CLOSE_MID_ACTIVITY_MODAL:
      uiState = _.cloneDeep(state.uiState)
      uiState.isMidActivityModalDisplayed = false
      return { ...state, uiState }

    case CLOSE_COMPLETED_ACTIVITY_MODAL:
      uiState = _.cloneDeep(state.uiState)
      uiState.isCompletedActivityModalDisplayed = false
      return { ...state, uiState }

    case CLOSE_INCORRECT_MODAL:
      uiState = _.cloneDeep(state.uiState)
      uiState.isIncorrectModalDisplayed = false
      return { ...state, uiState }

    case CLOSE_SLOW_DOWN_MODAL:
      uiState = _.cloneDeep(state.uiState)
      uiState.isSlowDownModalDisplayed = false
      return { ...state, uiState }

    case CLOSE_SLOW_DEDUCT_MODAL:
      uiState = _.cloneDeep(state.uiState)
      uiState.isSlowDeductModalDisplayed = false
      return { ...state, uiState }

    case CLOSE_EBOOK_MODAL:
      uiState = _.cloneDeep(state.uiState)
      uiState.isEbookModalDisplayed = false
      uiState.ebookModalDisplayValue = null
      return { ...state, uiState }

    case CLOSE_SPLIT_SCREEN_EBOOK_MODAL:
      uiState = _.cloneDeep(state.uiState)
      uiState.isSplitScreenEbookDisplayed = false
      uiState.isLegacyEbookDisplayed = false
      uiState.isEbookModalDisplayed = false
      return { ...state, uiState }

    case CHALLENGE_QUESTION_MODAL:
      uiState = _.cloneDeep(state.uiState)
      uiState.isChallengeQuestionModalDisplayed = true
      uiState.challengeQuestionValue = ''
      return { ...state, uiState }

    case CLOSE_CHALLENGE_QUESTION_MODAL:
      uiState = _.cloneDeep(state.uiState)
      uiState.isChallengeQuestionModalDisplayed = false
      uiState.challengeQuestionValue = ''
      uiState.challengeStep = ''
      uiState.challengeIssueTypeValue = ''
      uiState.challengeEmailValue = ''
      uiState.challengeQuestionError = false
      return { ...state, uiState }

    case CLOSE_CHALLENGE_SENT_MODAL:
      uiState = _.cloneDeep(state.uiState)
      uiState.isChallengeQuestionModalDisplayed = false
      uiState.challengeQuestionValue = ''
      uiState.challengeQuestionError = false
      uiState.isChallengeSentModalDisplayed = false
      return { ...state, uiState }

    case UPDATE_NETWORK_STATUS:
      uiState = _.cloneDeep(state.uiState)
      return { ...state, uiState }

    case NETWORK_STATUS_UP:
      uiState = _.cloneDeep(state.uiState)
      uiState.isNetworkUp = true
      return { ...state, uiState }

    case NETWORK_STATUS_DOWN:
      uiState = _.cloneDeep(state.uiState)
      uiState.isNetworkUp = false
      return { ...state, uiState }

    case SHOW_NETWORK_ISSUE_MODAL:
      uiState = _.cloneDeep(state.uiState)
      uiState.isShowNetworkIssueModalDisplayed = true
      return { ...state, uiState }

    case CLOSE_NETWORK_ISSUE_MODAL:
      uiState = _.cloneDeep(state.uiState)
      uiState.isShowNetworkIssueModalDisplayed = false
      return { ...state, uiState }

    case SHOW_PSP_EBOOK:
      uiState = _.cloneDeep(state.uiState)
      if (config.forceLpEnv === '1') {
        uiState.isLegacyEbookDisplayed = true
      }

      uiState.isSplitScreenEbookDisplayed = true
      return { ...state, uiState }

    case SHOW_EBOOK:
      activity = _.cloneDeep(state.activity)
      uiState = _.cloneDeep(state.uiState)

      if (config.forceLpEnv === '1') {
        uiState.isLegacyEbookDisplayed = true
      }

      return { ...state, activity, uiState }

    case SHOW_SPLIT_SCREEN_EBOOK:
      uiState = _.cloneDeep(state.uiState)
      uiState.isSplitScreenEbookDisplayed = true
      return { ...state, uiState }
      // end modal reducers

      // sample result reducers

    // exclusive to instructors to view sample results when there are no students in the roster
    case VIEW_SAMPLE_RESULTS: {
      const nextState = {
        ...state,
        activity: { ...(_.cloneDeep(state.activity)), isSampleData: true },
        activityBeforeViewSampleResults: _.cloneDeep(state.activity)
      }
      simulateInstructorData(nextState.activity)
      buildRetake(nextState.activity, {}, config.simulateRetake)
      finishInitialization(nextState.activity)
      return nextState
    }
    case VIEW_SAMPLE_LCRP_RESULTS: {
      const nextState = {
        ...state,
        activity: { ...(_.cloneDeep(state.activity)), isSampleData: true },
        activityBeforeViewSampleResults: _.cloneDeep(state.activity)
      }
      simulateLCRPData(nextState.activity)
      return nextState
    }
    case HIDE_SAMPLE_RESULTS: {
      const nextState = {
        ...state,
        activity: _.cloneDeep(state.activityBeforeViewSampleResults)
      }
      delete nextState.activityBeforeViewSampleResults
      finishInitialization(nextState.activity)
      return nextState
    }
    case VIEW_SAMPLE_TRENDS_DATA: {
      activity = _.cloneDeep(state.activity)
      simulateLCRPData(activity)
      const rosterObjects = constructRosterObjects(activity, activity.tmpSampleData.rosterData);
      const courseDashboardData = calculateCourseDashboardData(activity, activity.tmpSampleData.rosterData)
      const assignmentOverview = simulateLCRPTopicalPerformance(courseDashboardData.assignmentOverview)
      courseDashboardData.assignmentOverview = assignmentOverview
      return { ...state, courseDashboardData }
    }
    case HIDE_SAMPLE_TRENDS_DATA:
      return { ...state, courseDashboardData: {} }

      // tooltip reducers

    case SHOW_SCORE_TOOLTIP:
      uiState = _.cloneDeep(state.uiState)
      uiState.showScoreValueInfo = !uiState.showScoreValueInfo
      uiState.showQuestionValueInfo = false
      return { ...state, uiState }

    case SHOW_QUESTION_TOOLTIP:
      uiState = _.cloneDeep(state.uiState)
      uiState.showScoreValueInfo = false
      uiState.showQuestionValueInfo = !uiState.showQuestionValueInfo
      return { ...state, uiState }

      // challenge question reducers

    case NEXT_CHALLENGE_STEP:
      uiState = _.cloneDeep(state.uiState)
      uiState.challengeStep = action.value
      return { ...state, uiState }

    case CHANGE_CHALLENGE_VALUE:
      uiState = _.cloneDeep(state.uiState)
      uiState.challengeQuestionValue = action.value
      uiState.challengeQuestionError = uiState.challengeQuestionError ? action.value.length < 50 : false
      return { ...state, uiState }

    case CHANGE_CHALLENGE_ISSUE_TYPE:
      uiState = _.cloneDeep(state.uiState)
      uiState.challengeIssueTypeValue = action.value
      uiState.challengeQuestionErrorIssueType = false
      return { ...state, uiState }

    case CHANGE_CHALLENGE_EMAIL_VALUE:
      uiState = _.cloneDeep(state.uiState)
      uiState.challengeEmailValue = action.value
      uiState.challengeQuestionErrorEmail = false
      return { ...state, uiState }

    case CHALLENGE_INVALID_EMAIL:
      uiState = _.cloneDeep(state.uiState)
      uiState.challengeQuestionErrorEmail = true
      return { ...state, uiState }

    case CHALLENGE_INVALID_ISSUE_TYPE:
      uiState = _.cloneDeep(state.uiState)
      uiState.challengeQuestionErrorIssueType = true
      return { ...state, uiState }

    case CHALLENGE_INVALID:
      activity = _.cloneDeep(state.activity)
      uiState = _.cloneDeep(state.uiState)
      uiState.challengeQuestionError = true
      uiState.isChallengeQuestionModalDisplayed = true
      return { ...state, uiState }

    case CHALLENGE_SUCCESS:
      uiState = _.cloneDeep(state.uiState)
      uiState.isChallengeQuestionModalDisplayed = false
      uiState.challengeStep = 0
      uiState.challengeIssueTypeValue = ''
      uiState.challengeEmailValue = ''
      uiState.challengeEmailValue = ''
      uiState.isChallengeSentModalDisplayed = true
      uiState.challengeSendSuccessful = true
      return { ...state, uiState }

    case CHALLENGE_FAILURE:
      activity = _.cloneDeep(state.activity)
      uiState = _.cloneDeep(state.uiState)
      uiState.challengeStep = 0
      uiState.isChallengeQuestionModalDisplayed = false
      uiState.isChallengeSentModalDisplayed = true
      uiState.challengeSendSuccessful = false
      return { ...state, uiState }

      // miscellaneous reducers

    case CONTACT_TECH_SUPPORT:
      window.open('http://www.macmillanlearning.com/Catalog/techsupport')
      return { ...state }

    case FAQ:
      uiState = _.cloneDeep(state.uiState)
      uiState.showFaqPage = !uiState.showFaqPage
      uiState.isTipsForSuccessModalDisplayed = false
      return { ...state, uiState }

    // Keep track of topical comparison reports here instead of component state
    case UPDATE_RADIO_BUTTONS:
      uiState = _.cloneDeep(state.uiState)
      uiState.radioButtons[action.payload] = !uiState.radioButtons[action.payload]
      return { ...state, uiState }

    default:
      return state
  }
}
// end reducer switch

export const mergeQuestionViewData = (questions, questionViewData) => {
  return questions.map(q => _.merge({}, q, questionViewData?.find(pq => pq.meta?.fq_uid === q.meta?.fq_uid)))
}
